<template>
  <v-autocomplete
    v-model="values"
    :items="items"
    dense
    chips
    :label="'Search for ' + searchType"
    multiple @mousedown="setCompressedView(false)" @blur="setCompressedView(true); saveChanges($event);">
		<template v-if="selectSlot" v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item }}</span>
      </v-chip>
      <span
        v-if="index === 1"
        class="grey--text caption"
      >(+{{ values.length - 1 }} others)</span>
    </template>
	</v-autocomplete>
</template>

<script>
import Vue from "vue";
import { lookUpService } from "../../services/lookUpService";
import { CONSTANTS } from './../../common/constants';
export default {
  name: "RowPicker",
  props: {
	searchType: String,
	selectedCountries: Array
  },
  data: () => ({
    items: [],
    values: [],
		value: null,
		selectSlot: true
  }),
	watch: {

		selectedCountries: function (newVal, oldVal) {
			this.values = [];

			this.selectedCountries.forEach(entry => {
				if (entry.countryId != CONSTANTS.COUNTRY_STATIC_ROW_NAMES.A_ROW && entry.countryId != CONSTANTS.COUNTRY_STATIC_ROW_NAMES.C_ROW) {
					this.values.push(entry.countryId);
				}
			});

			this.values.sort();
		}
	},
  mounted () {
		const me = this;
        me.values = [];
		me.items = [];
		console.log("RowPicker: Attempting to load look up information for " + me.searchType);
		lookUpService.loadLookUp(me.searchType).then(function (response) {
		if (response && response.data) {
					console.log("RowPicker: Look up information loaded");
					me.items = response.data;
		}
    })
    .catch(function (e) {
      console.log(e);
      throw e;
		});
        this.values = [];
		this.selectedCountries.forEach(entry => {
			if (entry.countryId != CONSTANTS.COUNTRY_STATIC_ROW_NAMES.A_ROW && entry.countryId != CONSTANTS.COUNTRY_STATIC_ROW_NAMES.C_ROW) {
			this.values.push(entry.countryId);
			}
		});

		this.values.sort()
  },
  methods: {
		setCompressedView: function (val) {
			this.selectSlot = val;
		},
		saveChanges: function () {
			debugger;
			console.log("Saving Search Changes");
			this.values.sort();
			console.log("searchValues:", this.values);
			this.$emit('update', { searchValues: this.values });
		}
  }
};
</script>

<style scoped>
</style>
